import { useState, useEffect } from 'react';
import { Album } from '@/types/album';
import { appDataStore } from '@/services/cache/appDataStore';

/**
 * Resolve a song's fallback album cover (first album with artwork the song is
 * assigned to). Reactive: re-resolves when album membership loads in the
 * background. Pass enabled=false (e.g. the song has its own art) to skip.
 */
export function useSongFallbackAlbum(songId: number, enabled: boolean = true): Album | undefined {
  const [album, setAlbum] = useState<Album | undefined>(() =>
    enabled ? appDataStore.getSongFallbackAlbum(songId) : undefined
  );

  useEffect(() => {
    if (!enabled) {
      setAlbum(undefined);
      return;
    }
    const update = () => setAlbum(appDataStore.getSongFallbackAlbum(songId));
    update();
    return appDataStore.subscribe(update);
  }, [songId, enabled]);

  return album;
}
